import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ToastService, ToastType } from '../../shared/toast/toast.service';
import { CurrentUserService, UserGroupService } from '../../user/services';
import { InitConfigurationDialogComponent } from '../../distribution/init-configuration-dialog/init-configuration-dialog.component';
import { InitConfiguration } from '../../distribution/models/init-configuration';
import { ModalDismissStatus } from '../../distribution/models/modal-dismiss-status';
import { DataFieldGroup } from '../../shared/datafields/models';
import { GenericModalService, ModalSettingsTemplate } from '../../shared/generic-modal/generic-modal.service';
import { LoadingPanelService } from '../../shared/loading-panel/loading-panel.service';
import { ArtifactAssemblyTypes, AssemblyArtifact } from '../../developer/models/artifact';
import { AdvancedHttpHandlerEntity } from '../models/advanced-http-handler';
import { GridService } from '../../shared/grid/grid.service';
import { AdvancedHttpHandlerService } from '../services/advanced-http-handler-service';
import { DeveloperArtifactService } from 'src/app/developer/services/developer-artifact.service';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { PermissionRequiredDirective } from '../../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { DxDataGridModule, DxTextBoxModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../shared/grid/biz-grid.directive';
import { DxoColumnFixingModule, DxoEditingModule, DxiColumnModule, DxiValidationRuleModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { BizUserColumnDirective } from '../../shared/grid/biz-grid-user.directive';
import { BizDateColumnDirective } from '../../shared/grid/biz-grid-date.directive';
import { DxTemplateModule } from 'devextreme-angular/core';

import { DeveloperArtifactAssemblyPickerComponent } from '../../developer/developer-artifacts/developer-artifact-assembly-picker.component';
import { DataFieldGroupContainerComponent } from '../../shared/datafields/datafield-group-container.component';
import { BizGridFiltervalues } from 'src/app/shared/grid/biz-grid-filtervalues';
import { UserGroup } from '../../user/models';

@Component({
  selector: 'app-advanced-http-handlers',
  standalone: true,
  imports: [SvgIconComponent, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, DxDataGridModule, BizDataGridDirective, DxoColumnFixingModule, DxoEditingModule, DxiColumnModule, DxiValidationRuleModule, DxiButtonModule, BizUserColumnDirective, BizDateColumnDirective, DxTemplateModule, DxTextBoxModule, DeveloperArtifactAssemblyPickerComponent, DataFieldGroupContainerComponent],
  templateUrl: './advanced-http-handlers.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './advanced-http-handlers.component.scss'
})
export class AdvancedHttpHandlersComponent implements OnInit {

  hasCreatePerm = false;
    hasEditPerm = false;
    hasDeletePerm = false;
    allowShowLog = false;

    advancedHttpHandlers: AdvancedHttpHandlerEntity[] = [];
    artifacts: AssemblyArtifact[] = [];
    currentAdvancedHttpHandler: AdvancedHttpHandlerEntity | null;

    httpHandlerDisplayGroups: DataFieldGroup[] = [];
    httpHandlerFormGroup: UntypedFormGroup = new UntypedFormGroup({});

    baseApiUrl: string;

    userGroupChoices: {Id: number | null, Name: string}[] = []

    constructor(
        private advancedHttpHandlerService: AdvancedHttpHandlerService,
        private toastService: ToastService,
        private currentUserService: CurrentUserService,
        private loadingPanelService: LoadingPanelService,
        private modalService: GenericModalService,
        private developerArtifactService: DeveloperArtifactService,
        public bizGridFiltervalues: BizGridFiltervalues,
        private gridService: GridService,
        private userGroupService: UserGroupService) {

        this.allowUpdatingRow = this.allowUpdatingRow.bind(this);
        this.allowDeletingRow = this.allowDeletingRow.bind(this);
        this.displayExprArtifact = this.displayExprArtifact.bind(this);
    }

    ngOnInit() {
        void this.ngOnInitAsync();
    }

    async ngOnInitAsync() {
        this.artifacts = await this.developerArtifactService.getAssemblyArtifacts(true, [ArtifactAssemblyTypes.TypeAdvancedHttpHandler]);
        this.hasCreatePerm = this.currentUserService.hasPermission('AdvancedHttpHandler_Action_Create');
        this.hasEditPerm = this.currentUserService.hasPermission('AdvancedHttpHandler_Action_Edit');
        this.hasDeletePerm = this.currentUserService.hasPermission('AdvancedHttpHandler_Action_Delete');
        this.allowShowLog = this.currentUserService.hasPermission('AdvancedHttpHandler_Action_ShowLog');
        this.baseApiUrl = await this.advancedHttpHandlerService.getBaseApiUrl();
        if (this.baseApiUrl.slice(-1) !== '/') {
            this.baseApiUrl = this.baseApiUrl + '/';
        }
        const userGroupsSorted = (await this.userGroupService.getUserGroups()).sort((a, b) => (a.Name > b.Name ? 1 : -1));
        const defaultChoice: {Id: number | null, Name: string} = {Id: null, Name: 'Please choose'};
        this.userGroupChoices = [defaultChoice].concat(userGroupsSorted.map(x => ({Id: x.Id ,Name: x.Name })));
        await this.refresh();
    }


    allowUpdatingRow(options: { component: any; row: any; }): boolean {
        const item: AdvancedHttpHandlerEntity = options?.row?.data;
        if (item) {
            return this.hasEditPerm;
        }
        return false;
    }

    allowDeletingRow(options: { component: any; row: any; }): boolean {
        const item: AdvancedHttpHandlerEntity = options?.row?.data;
        if (item) {
            return this.hasDeletePerm;
        }
        return false;
    }
displayExprArtifact(e: any) {
        // TODO: Find en bedre måde at håndtere dette, så det ikke er nødvendigt at loade alle artifacts...
        if (this.artifacts) {
            var artifact = this.artifacts.find(a => a.ArtifactId == e.value);
            if (artifact) {
                return `${artifact.Name} [${artifact.ClassName}] [${artifact.Filename}]`;
            }
        }
        return 'Unknown...';
    }

    async refresh() {
        this.loadingPanelService.showLoadingPanelDirect('Loading http handlers...');
        this.advancedHttpHandlers = await this.advancedHttpHandlerService.getAdvancedHttpHandlers();
        this.httpHandlerDisplayGroups = [];
        this.currentAdvancedHttpHandler = null;
        this.loadingPanelService.hideLoadingPanel();
    }

    onInitNewRow(e: any): void {
        e.data = { Id: null, Name: '', Description: '' } as AdvancedHttpHandlerEntity;
    }

    onRowInserting = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as AdvancedHttpHandlerEntity, item => this.saveHttpHandler(item));
    };

    onRowUpdating = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow({ ...e.key, ...e.newData } as AdvancedHttpHandlerEntity, item => this.saveHttpHandler(item), e.newData);
    };

    onRowRemoving = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as AdvancedHttpHandlerEntity, item => this.removeHttpHandler(item));
    };

    async saveHttpHandler(advancedHttpHandler: AdvancedHttpHandlerEntity): Promise<AdvancedHttpHandlerEntity> {
        const httpHandlerExist = this.advancedHttpHandlers.find(i => i.Id != advancedHttpHandler.Id && i.UrlKey == advancedHttpHandler.UrlKey);
        if (httpHandlerExist != null) {
            throw new Error(`Another http handler with that UrlKey already exists. Name of the existing http handler: ${httpHandlerExist.Name}`);
        }

        const datafieldValues = DataFieldGroup.getDataFieldValues(this.httpHandlerDisplayGroups, true);
        const newHttpHandler = await this.advancedHttpHandlerService.saveAdvancedHttpHandler(advancedHttpHandler, datafieldValues);
        this.toastService.showToast('Http handler saved...', ToastType.success);
        return newHttpHandler;
    }

    async removeHttpHandler(advancedHttpHandler: AdvancedHttpHandlerEntity): Promise<AdvancedHttpHandlerEntity> {
        await this.advancedHttpHandlerService.deleteAdvancedHttpHandler(advancedHttpHandler.Id);
        this.toastService.showToast('Http handler deleted...', ToastType.success);
        return advancedHttpHandler;
    }

    async onEditingStart(e: any) {
        const plugin = e.data as AdvancedHttpHandlerEntity;
        this.currentAdvancedHttpHandler = plugin;
        e.component.cellValue(e.component.getRowIndexByKey(e.key), 'Name', e.component.cellValue(e.component.getRowIndexByKey(e.key), 'Name')); // Lidt hacky, men for at vi kan få de dynamiske datafield-værdier med i en save, hvor man ikke har ændret andet end disse værdier, så trigger vi en ændring her, så update altid bliver kaldt.
    }

    async onEditCancelled(e: any) {
        this.currentAdvancedHttpHandler = null;
        this.httpHandlerDisplayGroups = [];
    }

    async setArtifactId(artifactId: string, cellInfo: any) {
        cellInfo.setValue(artifactId || '');
        if (artifactId) {
            this.loadingPanelService.showLoadingPanelDirect('Loading config...');
            this.httpHandlerDisplayGroups = await this.advancedHttpHandlerService.getAdvancedHttpHandlerDataFieldGroups(artifactId, this.currentAdvancedHttpHandler?.Id);
            this.loadingPanelService.hideLoadingPanel();
        }
        else {
            this.httpHandlerDisplayGroups = [];
        }
    }

    getUserGroupSortValue = (handler: AdvancedHttpHandlerEntity) => this.userGroupChoices.find(u => u.Id === handler.AuthorizedUserGroupId)?.Name || ''

    getUserGroupDisplayValue = (handler: AdvancedHttpHandlerEntity) =>
    {
        if (!handler.AuthorizedUserGroupId)
            return '';
        return this.userGroupChoices.find(u => u.Id === handler.AuthorizedUserGroupId)?.Name || '';
    }

    trimLeadingSlashes(value: string | null | undefined): string {
        return (value ?? '').replace(/^\/+/, '');
    }
}
